export default "__VITE_ASSET__B$ScIBGp__"